<template>
    <div style="min-height: calc(100vh - 158px);">
        <div style="min-height: calc(100vh - 168px);" class="card">
            <div style="background: #DBE7F2" class="pb-1">
                <TitleButton
                    class="px-2 pt-2"
                    :showBtn="false"
                    title="Statement of financial position"
                    :show-filter-btn="true"
                    @onClickFilterButton="onClickFilterButton"
                />
                <div class="px-2">
                    <DateQuerySetter
                        btnTitle="Go"
                        @onClickGo="onClickGo"
                    >
                        <div class="cols-12 col-sm-6 col-lg-4 col-xl-3">
                            <label for="colFormLabel" class="col-form-label">Project</label>
                            <v-select
                                placeholder="Select Project"
                                :options="projects"
                                label="name"
                                :reduce="name => name.id"
                                v-model="projectId"
                            />
                        </div>
                        <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3">
                            <label for="colFormLabel" class="col-form-label">Business</label>
                            <v-select
                                placeholder="Select Business"
                                class="w-100"
                                :options="businesses"
                                label="name"
                                :reduce="name => name.id"
                                v-model="business_id"
                            />
                        </div>
                    </DateQuerySetter>
                </div>
            </div>

            <div class="mt-2"></div>
            <div class="">
              <button class="btn btn-success float-end me-4" @click="exportBalanceSheet">Export</button>
            </div>
            <div
                class="d-flex justify-content-between bg-white sticky px-2 mx-auto z-10 w-100 max-width-640"
                :class="{
                    'opacity-50': accountingLoading,
                    'opacity-100': !accountingLoading
                }"
            >
                <p class="cursor-pointer text-decoration-underline fw-bolder text-primary" @click="expandAll">
                    {{ isExpanded ? 'Collapse All' : 'Expand All' }}
                </p>
            </div>
            <div
                class="d-flex justify-content-between bordered bg-white sticky py-1 px-2 border-t border-b mx-auto z-10 max-width-640 w-100"
                :class="{
                    'opacity-50': accountingLoading,
                    'opacity-100': !accountingLoading
                }"
            >
                <strong class="font-medium-2">Particulars</strong>
                <strong class="font-medium-2">Amount</strong>
            </div>

            <div
                class="px-2 mt-1 mx-auto max-width-640 w-100"
                :class="{
                    'opacity-50': accountingLoading,
                    'opacity-100': !accountingLoading
                }"
            >
                <!-- asset -->
                <span> Assets</span>
                <div class="card">
                    <BalanceSheetTree
                        v-for="(assetItem, i) in asset"
                        :key="i"
                        :node="assetItem"
                        ref="assetTree"
                    />
                    <div class="d-flex justify-content-between border-b-2-dark node-hover node-hover">
                        <strong>TOTAL ASSETS</strong>
                        <strong> {{ commaFormat(getTotal(asset), noOfDecimals) }}</strong>
                    </div>
                </div>

                <!-- asset -->
                <!-- equity -->
                <span> Equity</span>
                <div class="card">
                    <BalanceSheetTree
                        v-for="(equityItem, i) in equity"
                        :key="i"
                        :node="equityItem"
                        ref="equityTree"
                    />
                    <div class="d-flex justify-content-between border-b-2-dark node-hover">
                        <strong>TOTAL EQUITY</strong>
                        <strong>{{ commaFormat(getTotal(equity), noOfDecimals) }}</strong>
                    </div>
                </div>
                <!-- equity -->
                <!-- liability -->
                <span> Liability</span>
                <div class="card">
                    <BalanceSheetTree
                        v-for="(liabilityItem, i) in liability"
                        :key="i"
                        :node="liabilityItem"
                        ref="liabilityTree"
                    />
                    <div class="d-flex justify-content-between border-b-2-dark node-hover">
                        <strong>TOTAL LIABILITIES</strong>
                        <strong>{{ commaFormat(getTotal(liability), noOfDecimals) }}</strong>
                    </div>
                    <div class="d-flex justify-content-between border-b-2-dark node-hover">
                        <strong>TOTAL LIABILITIES AND EQUITY</strong>
                        <strong>{{ commaFormat(getTotal(liability) + getTotal(equity), noOfDecimals) }}</strong>
                    </div>
                </div>
                <!-- liability -->
            </div>
        </div>
        <FilterModal v-if="isModalOpen" @on-filter="onFilter"/>
        <Loader v-if="accountingLoading"/>
    </div>
</template>

<script>
import handleAccounting from '@/services/modules/accounting'
import figureFormatter from '@/services/utils/figureFormatter'
import { inject } from 'vue'

import TitleButton from '@/components/atom/TitleButton'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import BalanceSheetTree from '@/components/molecule/company/balance-sheet/BalanceSheetTree'
import handleProjects from "@/services/modules/procurement/project";
import Loader from '@/components/atom/LoaderComponent'
import handleCBusinesses from '@/services/modules/businesses'
import FilterModal from "@/components/atom/FilterModal.vue";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";

export default {
    name: 'BalanceSheet',

    components: {
        ContactDropdownFilter,
        FilterModal,
        TitleButton,
        DateQuerySetter,
        BalanceSheetTree,
        Loader
    },

    data: () => ({
        asset: [],
        equity: [],
        liability: [],
        balanceSheetData: [],
        projects: [],
        projectId: null,
        businesses : [],
        business_id: null,
        showFilterModal: false,
    }),

    computed: {
        companyId() {
            return this.$route.params.companyId
        },

        start() {
            return this.$route.query.start
        },

        end() {
            return this.$route.query.end
        },
        noOfDecimals() {
            return this.$route.query.decimals ?? 2
        },
        token() {
          return localStorage.getItem('token')
        },
        isModalOpen() {
            return this.$store.state.isModalOpen
        },
        isExpanded() {
          return this.$route.query.expand_all ? !!parseInt(this.$route.query.expand_all) : false;
        }
    },

    methods: {
      exportBalanceSheet() {
        let url = `${process.env.VUE_APP_BASE_URL}/export/accounting/balance-sheet` + this.getQuery() + `&_token=${this.token}`;
        let a = document.createElement("a")
        a.setAttribute("href", url)
        a.click()
      },
        getTotal (data) {
            let total = 0
            data.map(i => {
                total += i.total
            })
            return total
        },

        onClickGo(filter) {
            this.getDateWiseBalanceSheet(this.getQuery(filter))
        },

        getQuery (filter) {
            const routeQuery = Object.assign({}, this.$route.query)
            const decimals = filter ? filter.decimals : routeQuery.decimals
            const showNonZero = filter ? filter.showNonZero : (routeQuery.show_non_zero ?? 1)

            let query = '?company_id=' + this.companyId
            if(!this.start && !this.end) return query
            if(this.start) query += '&start_date='+this.start
            if(this.end) query += '&end_date='+this.end
            if(this.projectId != null) query += `&project_id=${this.projectId}`
            if(this.business_id != null) query += `&business_id=${this.business_id}`
            if (decimals) query += `&decimals=${decimals}`
            if (showNonZero) query += `&show_non_zero=${showNonZero}`
            return query
        },

        onFilter (filter) {
            let routeQuery = Object.assign({}, this.$route.query);
            routeQuery.decimals = filter.decimals;
            routeQuery.show_non_zero = filter.showNonZero;
            this.$router.push({path: this.$route.path, query: routeQuery})
            this.onClickGo(filter)
        },

        async getProjects() {
            let query = `?company_id=${this.companyId}`;
            try {
                this.accountingLoading = true
                let res = await this.fetchProjects(query)
                if(!res.status) {
                    this.showError(res.response.message)
                }
                if(res.status) {
                    this.projects = res.data
                }
            } catch (err) {
                if(err.response?.data) {
                    this.showError(err.response.data.message)
                }
            } finally {
                this.accountingLoading = false
            }
        },

        expandAll() {
            const routeQuery = Object.assign({}, this.$route.query);
            const expandAll = !this.isExpanded;
            routeQuery.expand_all = expandAll ? 1 : 0;
            this.$router.push({path: this.$route.path, query: routeQuery})

            if (this.$refs.assetTree) {
                this.$refs.assetTree.forEach(child => child.expandTree(expandAll));
            }

            if (this.$refs.equityTree) {
                this.$refs.equityTree.forEach(child => child.expandTree(expandAll));
            }

            if (this.$refs.liabilityTree) {
                this.$refs.liabilityTree.forEach(child => child.expandTree(expandAll));
            }
        },

        async getDateWiseBalanceSheet(query = '') {
            try {
                this.accountingLoading = true
                let res = await this.getBalanceSheet(query)
                if(!res.status) {
                    this.showError(res.response.message)
                }
                if(res.status) {
                    this.balanceSheetData = res.data
                    this.asset = res.data.asset ? res.data.asset : []
                    this.equity = res.data.equity ? res.data.equity : []
                    this.liability = res.data.liability ? res.data.liability : []
                }
            } catch (err) {
                if(!err.response) {
                    this.showError('Something is wrong. Check your connectivity!!')
                }
                if(err.response?.data) {
                    this.showError(err.response.data.message)
                    return
                }
            } finally {
                this.accountingLoading = false
            }
        },
      async getBusinesses() {
        try {
          let companyId = this.$route.params.companyId
          let res       = await this.fetchBusinessList('?company_id=' + companyId)

          if (!res.status) {
          }
          if (res.status) {
            this.businesses = res.data;
          }

        } catch (err) {
          if (!err.response) {
            this.showError('Something is wrong. Check your connectivity!!')
          }
          if (err.response) {
            this.showError(err.response.message)
          }
        } finally {
          this.loading = false
        }

      },

        onClickFilterButton() {
            this.$store.state.isModalOpen = true
        },
    },

    setup() {
        const showError =  inject('showError');
        const showSuccess =  inject('showSuccess');

        const {
            getBalanceSheet,
            accountingLoading
        } = handleAccounting()

        const {
            fetchProjects
        } = handleProjects();

        const {commaFormat} = figureFormatter ()
        const {fetchBusinessList} = handleCBusinesses ()

        return {
            getBalanceSheet,
            fetchBusinessList,
            accountingLoading,
            commaFormat,
            showError,
            showSuccess,
            fetchProjects
        }
    },

    mounted () {
        this.getProjects();
        this.getDateWiseBalanceSheet(this.getQuery())
        this.getBusinesses()
    }
}
</script>

<style scoped>
span {
    font-size:1.2em;
}
.border-t {
    border-top: 1px solid #ebe9f1;
}
 .border-b {
    border-bottom: 1px solid #ebe9f1;
 }
</style>
